const facilityGroups = {
  list: {
    search: {
      placeholder: 'Buscar grupos de instalaciones...',
    },
    actions: {
      viewDetails: 'Ver Detalles',
      create: 'Nuevo Grupo',
      delete: (count: number) => `${count} grupos eliminados exitosamente`,
    },
    columns: {
      name: 'Nombre',
      externalId: 'ID Externo',
      facilities: 'Instalaciones',
    },
    facilitiesCount: 'Instalaciones',
    status: {
      lastUpdate: '\u00daltima actualizaci\u00f3n',
    },
    empty: {
      description: 'A\u00fan no se han creado grupos de instalaciones',
    },
    selected: (count: number) => `${count} seleccionados`,
    aria: 'Lista de grupos de instalaciones',
  },
  dialog: {
    createTitle: 'Crear Grupo de Instalaciones',
    editTitle: 'Editar Grupo de Instalaciones',
    form: {
      name: {
        label: 'Nombre',
        required: 'El nombre es obligatorio',
      },
      externalId: {
        label: 'ID Externo',
        required: 'El ID externo es obligatorio',
      },
      facilities: {
        label: 'Instalaciones',
        required: 'Las instalaciones son obligatorias',
      },
    },
    actions: {
      create: 'Crear',
      update: 'Actualizar',
      cancel: 'Cancelar',
    },
    createSuccess: 'Grupo de instalaciones creado exitosamente',
    updateSuccess: 'Grupo de instalaciones actualizado exitosamente',
    deleteSuccess: (count: number) =>
      `${count} grupos de instalaciones eliminados exitosamente`,
    genericError: 'Ocurri\u00f3 un error al guardar el grupo de instalaciones',
  },
  errors: {
    loadingGroups: (message: string) =>
      `Error al cargar grupos de instalaciones: ${message}`,
  },
};

const facilities = {
  list: {
    search: {
      placeholder: 'Buscar instalaciones...',
    },
    actions: {
      viewDetails: 'Ver Detalles',
      create: 'Nueva Instalaci\u00f3n',
      delete: (count: number) =>
        `${count} instalaciones eliminadas exitosamente`,
    },
    columns: {
      name: 'Nombre',
      type: 'Tipo',
      group: 'Grupo de Instalaciones',
    },
    selected: (count: number) => `${count} instalaciones seleccionadas`,
    aria: 'Lista de instalaciones',
  },
  dialog: {
    title: {
      create: 'Crear Instalaci\u00f3n',
      edit: 'Editar Instalaci\u00f3n',
    },
    actions: {
      create: 'Crear',
      update: 'Actualizar',
      cancel: 'Cancelar',
    },
  },
  form: {
    fields: {
      name: {
        label: 'Nombre de Instalaci\u00f3n',
        placeholder: 'Ingrese el nombre de la instalaci\u00f3n',
      },
      type: {
        label: 'Tipo de Instalaci\u00f3n',
        placeholder: 'Ingrese el tipo de instalaci\u00f3n',
      },
      timezone: {
        label: 'Zona Horaria',
        placeholder: 'Seleccione zona horaria',
      },
      address: {
        streetAddress: {
          label: 'Direcci\u00f3n',
          placeholder: 'Ingrese la direcci\u00f3n',
        },
        city: {
          label: 'Ciudad',
          placeholder: 'Ingrese la ciudad',
        },
        state: {
          label: 'Estado',
          placeholder: 'Ingrese el estado',
        },
        country: {
          label: 'Pa\u00eds',
          placeholder: 'Ingrese el pa\u00eds',
        },
        postalCode: {
          label: 'C\u00f3digo Postal',
          placeholder: 'Ingrese el c\u00f3digo postal',
        },
      },
    },
    messages: {
      createSuccess: 'Instalaci\u00f3n creada exitosamente',
      updateSuccess: 'Instalaci\u00f3n actualizada exitosamente',
      error: 'Ocurri\u00f3 un error al guardar la instalaci\u00f3n',
    },
  },
  messages: {
    deleteSuccess: (count: number) =>
      `${count} instalaciones eliminadas exitosamente`,
    error: 'Ocurri\u00f3 un error',
  },
  errors: {
    loadingFacilities: (message: string) =>
      `Error al cargar instalaciones: ${message}`,
  },
};

const logs = {
  rawPayloadParseError: 'Carga útil sin procesar (Error de análisis)',
  unknownEventType: 'Tipo de evento desconocido',
  unknownEvent: 'Evento desconocido',
  noDataAvailable: 'No hay datos disponibles',
  events: {
    facilityCreated: 'Instalación Creada',
    facilityUpdated: 'Instalación Actualizada',
    facilityDeleted: 'Instalación Eliminada',
    facilityGroupAssigned: 'Grupo de Instalación Asignado',
    facilityGroupRemoved: 'Grupo de Instalación Eliminado',
    facilityGroupCreated: 'Grupo de Instalaciones Creado',
    facilityGroupUpdated: 'Grupo de Instalaciones Actualizado',
    facilityGroupDeleted: 'Grupo de Instalaciones Eliminado',
  },
};

export const es = {
  facilityGroups,
  facilities,
  logs,
};
